import React, { createContext, useContext, useEffect, useState } from 'react';

const LangContext = createContext({ lang: 'en', setLang: () => {} });

export function LangProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem('dg-lang') || 'en');
  useEffect(() => {
    localStorage.setItem('dg-lang', lang);
    document.documentElement.lang = lang;
  }, [lang]);
  return <LangContext.Provider value={{ lang, setLang }}>{children}</LangContext.Provider>;
}

export function useLang() {
  const { lang, setLang } = useContext(LangContext);
  const t = (v) => {
    if (v && typeof v === 'object' && !Array.isArray(v) && 'en' in v) return v[lang] ?? v.en;
    return v;
  };
  return { lang, setLang, t, toggle: () => setLang((l) => (l === 'en' ? 'fr' : 'en')) };
}
